<template>
    <div class="dropdown">
        <button type="button" class="btn btn-link" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-table"></i>
        </button>
        <div class="dropdown-menu select-table-dimension">
            <div class="line">
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
            </div>
            <div class="line">
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
            </div>
            <div class="line">
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
            </div>
            <div class="line">
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
            </div>
            <div class="line">
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
            </div>
            <div class="line">
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
            </div>
            <div class="line">
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
            </div>
            <div class="line">
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
                <div class="square" v-on:mouseover="highlight" v-on:click="select"><div class="inner"></div></div>
            </div>
            <div class="dropdown-divider"></div>
            <small>1x1</small>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TableSelector",
        props: {
            inverted: Boolean
        },
        mounted: function() {
            $(this.$el).on("hide.bs.dropdown", this.onHideDropdown);
            // Fixing a bug between bootstrap and material design...
            $(this.$el).find("button").dropdown();
        },
        beforeDestroy: function() {
            $(this.$el).off("hide.bs.dropdown", this.onHideDropdown);
        },
        methods: {
            onHideDropdown: function() {
                // Setting the first element.
                this.highlight({
                    target: $(this.$el).find(".select-table-dimension").first().first()
                });
            },
            dimensions: function($el) {
                if (this.inverted === true) {
                    return [
                        Math.max($el.index() + 1, 1),
                        Math.max($el.parent().siblings(":last").index() - $el.parent().index() - 1, 1),
                    ];
                } else {
                    return [
                        Math.max($el.index() + 1, 1),
                        Math.max($el.parent().index() + 1, 1)
                    ];
                }
            },
            highlight: function(event) {
                const root = $(this.$el).find(".select-table-dimension");
                const allSquares = root.find(".square");
                let el = $(event.target);
                if (!el.hasClass("square")) {
                    el = el.closest(".square");
                }

                const dim = this.dimensions(el);
                allSquares.removeClass("highlight");

                if (this.inverted === true) {
                    const z = dim[1] + 2;
                    root.find(".line:nth-last-child(-n+" + z + ") .square:nth-child(-n+" + dim[0] + ")")
                        .addClass("highlight");
                } else {
                    root.find(".line:nth-child(-n+" + dim[1] + ") .square:nth-child(-n+" + dim[0] + ")")
                        .addClass("highlight");
                }
                root.find("small").html("" + dim[0] + "x" + dim[1]);
            },
            select: function(event) {
                let el = $(event.target);
                if (!el.hasClass("square")) {
                    el = el.closest(".square");
                }

                const dim = this.dimensions(el);
                this.$emit("click", {
                    columns: dim[0],
                    rows: dim[1]
                });
            }
        }
    };
</script>

<style scoped>
    .btn-link {
        color: rgb(163, 175, 183);
        line-height: 14px;
        margin-bottom: 0;
        margin-top: 1px;
        padding-left: 12px;
        padding-right: 12px;
    }
    .btn-link:hover {
        color: rgb(17, 17, 17);
    }

    .select-table-dimension {
        margin-top: 0;
        padding: 10px;
        padding-bottom: 5px;
    }
    .select-table-dimension .dropdown-divider {
        margin-bottom: 2px;
    }
    .select-table-dimension .line {
        min-width: 146px;
        height: 24px;
        cursor: pointer;
    }
    .select-table-dimension .square {
        padding-left: 2px;
        padding-right: 2px;
        display: inline-block;
    }
    .select-table-dimension .square .inner {
        height: 20px;
        width: 20px;
        border-radius: 1px;
        border: 1px solid #bfd3e8;
        background: #fff;
    }
    .select-table-dimension .square:hover .inner, .select-table-dimension .square.highlight .inner {
        background: #247cf029;
    }
</style>
